@if(component){
<div class="wrap flex-top flex flex-column-s flex-column-m p-t-10 p-b-10">
    <div class="flex-column w-6 w-12-s w-12-m m-r-10-x m-r-10-l">
        <text-box class="w-12 flex flex-middle"
                  [data]="component" />
        <div class="w-12 m-t-10 m-t-4-s m-t-4-m flex">
            <!-- length -->
            <form-mui-field [label]="'Length' | translate"
                            class="w-4">
                <input class="bg-col-w"
                       type="number"
                       [(ngModel)]="data.roomLength"
                       (ngModelChange)="calculateResult()"
                       name="length"
                       required />
            </form-mui-field>
            <div class="p1 m-l m-r m-l-2-s m-r-2-s m-l-2-m m-r-2-m flex flex-middle">x</div>
            <!-- width -->
            <form-mui-field [label]="'Width' | translate"
                            class="w-4">
                <input class="bg-col-w"
                       type="number"
                       name="width"
                       [(ngModel)]="data.roomWidth"
                       (ngModelChange)="calculateResult()"
                       required />
            </form-mui-field>
            <div class="p1 m-l m-r m-l-2-s m-r-2-s m-l-2-m m-r-2-m flex flex-middle">x</div>
            <!-- height -->
            <form-mui-field [label]="'Height' | translate"
                            class="w-4">
                <input class="bg-col-w"
                       type="number"
                       name="height"
                       [(ngModel)]="data.roomHeight"
                       (ngModelChange)="calculateResult()"
                       required />
            </form-mui-field>
        </div>
        <div class="m-t w-12 flex">
            <form-mui-field [label]="'Product' | translate"
                            class="w-6 m-r">
                <select class="bg-col-w"
                        type="text"
                        name="productId"
                        [(ngModel)]="data.productId"
                        (change)="onProductChange()"
                        required>
                    @for (product of products; track product.id) {
                    <option [value]="product.id">
                        {{ product.name }}
                    </option>
                    }
                </select>
            </form-mui-field>
            <form-mui-field [label]="'Product Options' | translate"
                            class="w-6">
                <select class="bg-col-w"
                        type="text"
                        name="productOptionId"
                        [(ngModel)]="data.productOptionId"
                        (ngModelChange)="calculateResult()"
                        required>
                    @for (option of productOptions; track option.id) {
                    <option [value]="option.id">
                        {{option.data?.thickness | optionLabel : 'thickness' }}
                    </option>
                    }
                </select>
            </form-mui-field>
        </div>
        <div class="m-t">
            <form-mui-field [label]="'Desired Reverberation Time' | translate"
                            class="w-12">
                <select class="bg-col-w"
                        type="text"
                        name="reverbTime"
                        [(ngModel)]="data.reverbTime"
                        (change)="calculateResult()"
                        required>
                    @for (time of component.reverbTimes; track time) {
                    <option [value]="time.value">
                        {{ time.label }}
                    </option>
                    }
                </select>
            </form-mui-field>
        </div>
        <div class="m-t flex">
            <p class="h3 s1-s s1-m col-1 m-r-2">{{'Recommended Product Square Footage' | translate}}:</p>
            <span class="h3 col-3">{{result}} sq ft</span>
        </div>
    </div>
    <df-image-wrapper class="overflow-hidden m-t-4-s m-t-4-m b-a b-col-5 w-6 w-12-s w-12-m"
                      style="border-radius: 12px;">
        <img [ratio]="component.ratio || '3/2'"
             [dfImage]="component.image">
    </df-image-wrapper>
</div>
}